// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"47c44769","787":"efb386b7"}[chunkId] + ".chunk.js";
};